import * as React from "react";

type PopupMenuContentItemProps = {
  content?: React.ReactNode;
};

export default function PopupMenuContentItem(props: PopupMenuContentItemProps) {
  return <div className="popup-menu-section-content-item">{props.content}</div>;
}
